export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
    hourCycle: 'h24'
}

export const PAGE_HEADERS = {
    ASL_DEVICES: {
        head: "asl.heading",
        headAlt: "ASL Devices",
        desc: "asl.desc",
        descAlt: "This page shows the real-time status of ASL devices along with the device and ASL Guided Divert Configuration"
    },
    ADTA_DEVICES: {
        head: "adta.heading",
        headAlt: "ADTA Devices",
        desc: "adta.desc",
        descAlt: "This page shows the real-time status of ADTA devices along with the Sorter Destination and Sorter Test Package Configuration"
    },
    THIN_CLIENTS: {
        head: "thinclients.heading",
        headAlt: "Thin Clients",
        desc: "thinclient.desc",
        descAlt: "This page shows the real-time status of Thin Client devices along with the MAC/IP Address and health status"
    },
    SBL_DEVICES: {
        head: "sbl.heading",
        headAlt: "SBL Devices",
        desc: "sbl.desc",
        descAlt: "This page shows the real-time status of LED Controllers along with the MAC/IP Address and Connectivity"
    },
    DEVICE_MANAGEMENT: {
        head: "devicemanagement.heading",
        headAlt: "Device Management",
        desc: "devicemanagement.desc",
        descAlt: "This page shows the real-time status of Automation devices, Thin Clients and SBL devices and helps you to set configuration of the selected device type."
    }
}

export const ACTIVE = "ACTIVE"
export const INACTIVE = "INACTIVE"
export const ONLINE_OK = "connected"
export const HEALTH_OK = "HEALTHY"

export const SECONDARY = "Secondary"
export const PRIMARY = "Primary"

export const ADTA_ASSET_TYPE = "ADTA"
export const ASL_ASSET_TYPE = "ASL"
export const THIN_CLIENT_ASSET_TYPE = "EDGE_GATEWAY"
export const SBL_ASSET_TYPE = "SBL"

export const ERROR_METRIC_SUFFIX = "Error";
export const LOADING_FAILED = "Loading Failed!"
export const ALL_CONFIG = "ALL"

export const ENDPOINT_ADD_ASSET = "addAsset";
export const ENDPOINT_UPDATE_ASSET = "updateAsset";
export const ENDPOINT_SET_ASSET_STATUS = "setAssetStatus";
export const ENDPOINT_GET_ASSET_BY_ASSET_TYPE = "getAssets";
export const ENDPOINT_GET_ADTA_STATUS = "ndms/getADTAStatus";
export const ENDPOINT_GET_ASL_STATUS = "ndms/getASLStatus";
export const ENDPOINT_GET_ASSET_BY_ASSET_LABEL = "getAssetByAssetLabel"
export const ENDPOINT_GET_THIN_CLIENT_STATUS = "getThinClientStatus"
export const ENDPOINT_DEPLOY_THIN_CLIENT = "deployToThinClient"
export const ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS = "getThinClientDeployment"
export const PROCESS_NODE_RESOURCE = "nodeResource";

export const EMPTY_STRING_PLACEHOLDER = "-"
export const EMPTY_STRING = ""
export const TIMEOUT_STRING = "timeout"
export const LOADING_STRING = "Loading"

export const BLUE_COLOR = "#055D7B"
export const ORANGE_COLOR = "#FF714D"
export const GREY_COLOR = "#F0F1F2"

export const ALERT_ASSET_STATUS_MESSAGE = "Failed to update Asset Status to Active. Try again!"
export const ALERT_UPDATE_ASSET_MESSAGE = "Failed to update asset details. Try again!"


// WEBPACK FOOTER //
// ./src/components/util/Constants.js